<!--充值记录列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">充值记录</span>
      </div>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <span class="subtitle">用户ID:</span>
        <Input
          v-model="page.account"
          placeholder="请输入用户ID"
          style="width: 150px; margin: 0 10px"
        >
        </Input>
        <span class="subtitle">订单号:</span>
        <Input
          v-model="page.order_no"
          placeholder="请输入订单号"
          style="width: 150px; margin: 0 10px"
        >
        </Input>
        <span class="subtitle">充值类型:</span>
        <Select
          v-model="page.type"
          style="width: 100px; text-align: center; margin: 0 10px"
        >
          <Option :value="100">全部</Option>
          <Option :value="0">人工</Option>
          <Option :value="1">支付宝</Option>
          <Option :value="2">微信</Option>
        </Select>
        <span class="subtitle">记录时间:</span>
        <DatePicker
          :value="page.start"
          format="yyyy-MM-dd"
          type="date"
          placement="bottom-end"
          placeholder="开始日期"
          style="width: 130px; margin: 0 5px"
          :editable="false"
          @on-change="(value) => (page.start = value)"
        ></DatePicker>
        <span>至</span>
        <DatePicker
          :value="page.end"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          style="width: 130px; margin: 0 5px"
          :editable="false"
          @on-change="(value) => (page.end = value)"
        ></DatePicker>
      </div>
      <div class="bottom">
        <Button type="primary" style="margin: 0 0 0 5px" @click="getData">查询</Button>
        <Button style="margin: 0 0 0 5px" @click="reset">重置</Button>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <Button style="margin: 0 5px">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>
    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoad"
        @on-sort-change="tableSort"
      />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>

    <Modal width="400" title="订单退款" v-model="modalRefunds.visible">
      <div style="margin-left: 30px">
        退款金额:
        <Input
          style="margin-left: 15px; width: 250px"
          v-model="modalRefunds.data.money"
          placeholder="请输入退款金额"
          type="number"
        />
      </div>
      <div slot="footer">
        <Button @click="modalRefunds.visible = false" stlye="margin-right:5px"
          >取消</Button
        >
        <Button
          @click="handlerRefund"
          type="primary"
          v-preventReClick
          :loading="modalRefunds.loading"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { verifyDate, monDiff } from '@/libs/util'
export default {
  data () {
    return {
      modalRefunds: {
        visible: false,
        data: { id: 0, money: 0 },
        loading: false
      },
      page: {
        p: 0,
        l: 10,
        type: 100,
        account: '',
        order_no: '',
        start: '',
        end: '',
        date: [],
        key: 'recharge.id',
        order: 'desc'
      },
      dateOption: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now()
        }
      },
      columns: [
        // {
        //   title: "编号",
        //   key: "id",
        //   sortable: "custom",
        //   _sortKey: "recharge.id",
        // },
        // {
        //   title: "用户编号",
        //   key: "user_id",
        //   sortable: "custom",
        //   _sortKey: "recharge.user_id",
        // },
        {
          title: '充值时间',
          key: 'create_time',
          render: (h, data) => {
            return h('span', this.$moment(new Date(data.row.create_time)))
          },
          sortable: 'custom',
          _sortKey: 'recharge.note'
        },
        { title: 'ID账号', key: 'account' },
        { title: '用户', key: 'name' },
        { title: '用户电话', key: 'tel' },
        { title: '订单号', key: 'order_no' },
        { title: '充值金额', key: 'money' },
        {
          title: '类型',
          key: 'type',
          render: (h, data) => {
            switch (data.row.type) {
              // 0人工 1支付宝 2微信
              case 0:
                return h('span', {}, '人工')
                break
              case 1:
                return h('span', {}, '支付宝')
                break
              case 2:
                return h('span', {}, '微信')
                break
            }
          },
          sortable: 'custom',
          _sortKey: 'recharge.type'
        },
        { title: '备注', key: 'note', tooltip: true },
        {
          title: '操作',
          key: 'actions',
          render: (h, data) => {
            let temp = []
            if (data.row.type == 1 && data.row.refund < data.row.money) {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'warning' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.GetUserInfo({ id: data.row.user_id }).then((res) => {
                          if (!res.status) {
                            this.$Message.error(res.msg)
                            return
                          }
                          let orderMoney = data.row.money - data.row.refund
                          if (res.data.money < orderMoney) orderMoney = res.data.money
                          this.modalRefunds.data = {
                            id: data.row.id,
                            money: orderMoney
                          }
                          this.modalRefunds.visible = true
                        })
                      }
                    }
                  },
                  '退款'
                )
              )
            }
            return temp
          }
        }
      ],
      data: [],
      total: 0,
      tableLoad: false
    }
  },
  methods: {
    tableSort (col) {
      this.page.key = col.column._sortKey
      this.page.order = col.order
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    reset () {
      this.page = {
        p: 0,
        l: 10,
        type: 100,
        account: '',
        order_no: '',
        start: '',
        end: '',
        date: [],
        key: 'recharge.id',
        order: 'desc'
      }
      this.setDate()
      if (this.page.type === 100) {
        this.getData()
      } else {
        this.page.type = 100
      }
    },
    setDate () {
      /* let temp = new Date();
      temp.setDate(1);
      // temp.setMonth(temp.getMonth() - 1);
      this.page.date = [
        this.$moment(temp, "YYYY-MM-DD"),
        this.$moment(new Date(), "YYYY-MM-DD"),
      ];
      this.page.start = this.$moment(temp, "YYYY-MM-DD");
      this.page.end = this.$moment(new Date(), "YYYY-MM-DD"); */
    },
    getData () {
      if (this.page.start && this.page.end && verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }
      /* if (monDiff(this.page.start, this.page.end) > 12) {
        //如果时间跨度超过一年就提示
        this.$Message.error("筛选的时间跨度不能超过1年");
        return;
      } */
      this.tableLoad = true
      this.page.date = [this.page.start, this.page.end]
      this.rechargeList(this.page).then((res) => {
        this.data = res.data
        this.total = res.total
        this.tableLoad = false
      })
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '充值记录'
      }
      this.columns.map((item) => {
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        this.page.p = 0
        this.page.l = this.total
        this.rechargeList(this.page).then((res) => {
          res.data.map((item) => {
            item.type = item.type ? (item.type === 1 ? '支付宝' : '微信') : '人工'
            item.create_time = this.$moment(item.create_time)
          })
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        this.data.map((item) => {
          item.create_time = this.$moment(item.create_time)
          item.type = item.type ? (item.type === 1 ? '支付宝' : '微信') : '人工'
        })
        params.data = this.data
        excel.export_array_to_excel(params)
      }
    },
    handlerRefund () {
      if (!this.modalRefunds.data.id) {
        this.$Message.error('参数错误')
        return false
      }
      if (!this.modalRefunds.data.money || this.modalRefunds.data.money <= 0) {
        this.$Message.error('金额错误')
        return false
      }
      this.RechargeRfund(this.modalRefunds.data).then((res) => {
        if (!res.status) {
          this.$Message.error(res.msg)
          return false
        }
        this.getData()
        this.$Message.success(res.msg)
        this.modalRefunds.data = {
          id: 0,
          money: 0
        }
        this.modalRefunds.visible = false
      })
      /*  this.RefundErrorJob({ pay_no: this.modalRefunds.data.pay_no }).then(res => {
        if (res.code !== 200) {
          this.$Message.error(res.msg);
          return false;
        }
        this.$Message.success(res.msg);
        this.modalRefunds.data.pay_no = '';
        this.modalRefunds.visible = false;
      }) */
    },
    ...mapActions(['rechargeList', 'RechargeRfund', 'GetUserInfo'])
  },
  mounted () {
    this.setDate()
    this.getData()
  },
  computed: mapGetters({}),
  watch: {
    'page.type' (n, o) {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
